import { handlePageInactive, handlePageReactive, handlePostEndSessionRequest } from '@/utils/tools';
import { bridgeCallFunc } from '@/utils/instantLoaded/tools';
import transifyReporter from '@/utils/transifyReporter';
import coreStore from '@/stores/core';
import reporter from '@/utils/report';
import { sleep } from '@/utils/agent';
import chatbotCommonVariable from '@/utils/common';

const intervalExecute = async (callback, defaultTime = 500) => {
  let i = 0;
  while (i++ < 3) {
    callback();

    await sleep(defaultTime);
  }
  // pop webview 的 lock 根据这里的逻辑 尝试三次之后还是吧就 打开 lock 可以再次点击 返回
  chatbotCommonVariable.UPDATE_POP_WEB_VIEW_LOCK(false);
};

const handlePopWebView = () => {
  const { sessionId: chatbotSessionId } = coreStore.safeGetStore('initStore');
  window.bridgeCallHandler('popWebView', {}, function (res) {
    reporter.apiLogBeforeUnload(
      `【call bridge popWebView callback】Service CSAT SessionId:${chatbotSessionId};errorMsg:${JSON.stringify(res)}`,
      { level: 'debug' },
    );
  });
};

export const handleTapBack = () => {
  bridgeCallFunc(() => {
    // 上报缺失transify key
    transifyReporter.report();
    const { sessionId: chatbotSessionId } = coreStore.safeGetStore('initStore');

    intervalExecute(handlePopWebView);

    reporter.apiLogBeforeUnload(
      `【call bridge popWebView】by Service CSAT SessionId:${chatbotSessionId}}`,
      { level: 'debug' },
    );

    // @MARK: 退出页面后 viewController 可能未能及时回收导致 viewDidDisappear applicationWillResignActive 被执行
    window.bridgeUnRegisterHandler('viewDidDisappear', () => {
      reporter.apiLogBeforeUnload(
        `【call bridge viewDidDisappear callback】by Service CSAT SessionId:${chatbotSessionId}}`,
        { level: 'debug' },
      );
      handlePageInactive();
      handlePostEndSessionRequest();
    });
    window.bridgeUnRegisterHandler('applicationWillResignActive', () => {
      reporter.apiLogBeforeUnload(
        `【call bridge applicationWillResignActive callback】by Service CSAT SessionId:${chatbotSessionId}}`,
        { level: 'debug' },
      );
      handlePageInactive();
      handlePostEndSessionRequest();
    });
    window.bridgeUnRegisterHandler('applicationDidBecomeActive', handlePageReactive);
  });
};
